export { default as AppErrorBoundary } from './error-boundary';
